module.exports = {"620403001":"长征街道","620403002":"电力路街道","620403003":"红会路街道","620403004":"兴平路街道","620403100":"王家山镇","620403101":"水泉镇","620403102":"共和镇","620403105":"宝积镇","620403106":"黄峤镇","620403203":"种田乡","620403204":"复兴乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620403.json
// module id = 3042
// module chunks = 0